/**
 * Classifies apiRequest results so callers can tell a temporary API outage
 * (load balancer 502/503/504, saturated API VMs, dropped connection) from a
 * genuine refusal. apiRequest tags HTTP errors with `httpStatus` when
 * getFullResult is set, and resolves network failures as `{ cancel: true }`;
 * requests we aborted ourselves carry `aborted: true` and are not outages.
 */
export const isServiceUnavailableResult = (result) => {
  if (!result || typeof result !== "object") return false;
  if (result.cancel === true) return !result.aborted;
  return Number(result.httpStatus) >= 500;
};

export const isAbortedResult = (result) =>
  Boolean(result && result.cancel === true && result.aborted);
